import React, { Component } from 'react';
import Model from "./Model";
import DiagramUtils from "../utils/DiagramUtils";
import MouseClickSensor from "../utils/MouseClickSensor";
import { } from "./Rectangle/RectangleUI";
import { } from "./Ellipse/EllipseUI";
import { } from "./Text/TextUI";
import { } from "./Picture/PictureUI";
import { } from "./Link/LinkUI";
import { } from "./Carousel/CarouselUI";
import { } from "./DataText/DataTextUI";
import { } from "./DataTable/DataTableUI";
import { } from "./DateTime/DateTimeUI";
import { } from "./CountDown/CountDownUI";
import { } from "./Group/GroupUI";
import { } from "./Group/GroupShellUI";
import { } from "./DiagramViewer/DiagramViewerUI";
// import { } from "./antd/Dialog/DialogUI";
// import { } from './ECharts';
// import { } from './ImageText/ImageTextUI';
// import VideoUI from "./Video/VideoUI";
// import { } from "./Map";
// import { } from "./Map3d/Map3dUI";
// import { } from "./Cesium/CesiumUI";
// // import { len } from 'echarts-gl';

// import { } from './Script/ScriptUI';
// import { } from './ConditionDiagram/ConditionDiagramUI';
// import { } from './Template/TemplateUI';
// import { } from './SearchPage/SearchPageUI';
// import { } from './EzvizCamera/EzvizCameraUI';
// import { } from './EzOpenMonitor/EzOpenMonitorUI';
// import { } from './HTag/HTagUI';
// import { } from './ImgViewer/ImgViewerUI';

// import { } from "./antd/Button/ButtonUI";
// import { } from "./antd/Button/ButtonGroupUI";
// import { } from "./antd/Button/ActionButtonUI";
// import { } from './antd/Button/RadioActionButtonGroupUI';
// import { } from './antd/Grid/GridUI';
// import { } from './antd/Grid/GridGroupUI';
// import { } from './antd/Tabs/TabsUI';
// import { } from './antd/Table/TableUI';
// import { } from './antd/Form/FormUI';
// import { } from './antd/Form/FormGroupUI';
// import { } from './antd/Form/FormItemUI';
// import { } from './antd/Input/InputUI';
// import { } from './antd/Input/InputSearchUI';
// import { } from './antd/Input/InputPasswordUI';
// import { } from './antd/Input/InputTextUI';
// import { } from './antd/Input/InputNumberUI';
// import { } from './antd/Switch/SwitchUI';
// import { } from './antd/Checkbox/CheckboxUI';
// import { } from './antd/Checkbox/CheckboxGroupUI';
// import { } from './antd/Radio/RadioUI';
// import { } from './antd/Radio/RadioButtonUI';
// import { } from './antd/Radio/RadioGroupUI';
// import { } from './antd/Select/SelectUI';
// import { } from './antd/DateTimePicker/TimePickerUI';
// import { } from './antd/DateTimePicker/DatePickerUI';
// import { } from './antd/DateTimePicker/DateRangePickerUI';
// import { } from './antd/Tooltip/TooltipUI';
// import { } from './antd/Popover/PopoverUI';
// import { } from './antd/Popconfirm/PopconfirmUI';
// import { } from './antd/Divider/DividerUI';
// import { } from './antd/Slider/SliderUI';
// import { } from './antd/Dropdown/DropdownButtonUI';
// import { } from './antd/Dropdown/DropdownUI';
// import { } from './antd/Progress/ProgressUI';
// import { } from './antd/Spin/SpinUI';
// import { } from './antd/Drawer/DrawerUI';
// import { } from './antd/Tag/TagUI';
// import { } from './antd/Cascader/CascaderUI';
// import { } from './antd/Menu/MenuUI';
// import { } from './HtmlViewer/HtmlViewerUI';
// import { } from './ArrowLinkLine/ArrowLinkLineUI';
// import { } from "./PhotoSphereViewer/PhotoSphereViewer";
// import { } from './DropdownZoneNavigator/DropdownZoneNavigatorUI';
// import { } from './EChartsV4/EChartsV4UI';
// import { } from './antd/List/ListUI';
// import { } from './ObjectPropertiesViewer/ObjectPropertiesViewerUI';
// import { } from './AutoScrollTable/AutoScrollTableUI';

// import { } from './NodeLine/NodeLineUI';
// import { } from './AnimateNumber/AnimateNumberUI';
// import { } from './PropertyGrid/PropertyGridUI';
// import { } from './AceEditor/AceEditorUI';
// import { } from './DataGrid/DataGridUI';
// import { } from './antd/Tree/TreeUI';


// import { } from './HikCamera/HikCameraUI';

export default class Diagram extends Component {

    state = {}

    style = ""
    // mouseClickSensor = new MouseClickSensor(undefined, e => this.onMouseDoubleClick(e));

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

        this.designer = this.props.designer;
        this.props.model.listenRefsPropertyChanged();
        this.unregisterPropertyChangedListener = this.props.model.registerPropertyChangedListener((name, valOld, valNew) => {
            this.designer.properties.needSave = true;

            if (name === "x" || name === "y") {
                this.updateLayout();
                return;
            }
            else if (name === "isExpanded") {
                return;
            }

            this.setState({});
        });

        // setTimeout(() => {

        //     this.dom = document.getElementById(this.props.model.id);
        //     // this.dom.setAttribute("style", this.style);
        //     this.dom.addEventListener("mousedown", this.onMouseDownHandler = this.onMouseDown.bind(this));
        //     this.dom.addEventListener("mouseup", this.onMouseUpHandler = this.onMouseUp.bind(this));
        //     this.dom.addEventListener("mousewheel", this.onMouseWheelHandler = this.onMouseWheel.bind(this));
        //     this.props.model._sys.dom = this.dom;

        //     this.setState({});
        // }, 0);
    }

    componentDidMount() {
        setTimeout(() => {
            this.updateLayout();
            // const c = this.props.model;
            // c.flag = Math.random();
        }, 0);
    }

    componentWillUnmount() {
        this.unregisterPropertyChangedListener();
        this.props.model.unlistenRefsPropertyChanged();

        if (this.dom) {
            this.dom.removeEventListener("mousedown", this.onMouseDownHandler);
            this.dom.removeEventListener("mouseup", this.onMouseUpHandler);
            this.dom.removeEventListener("mousewheel", this.onMouseWheelHandler);
        }
    }

    setDom(dom) {
        if (this.dom)
            return;

        this.dom = dom;
        this.dom.addEventListener("mousedown", this.onMouseDownHandler = this.onMouseDown.bind(this));
        this.dom.addEventListener("mouseup", this.onMouseUpHandler = this.onMouseUp.bind(this));
        this.dom.addEventListener("mousewheel", this.onMouseWheelHandler = this.onMouseWheel.bind(this));
        this.props.model._sys.dom = this.dom;

        this.setState({});
    }

    updateLayout() {

        if (!this.dom)
            return;

        const c = this.props.model;
        c._sys.designer = this.designer;
        c._sys.dom = this.dom;
        c._sys.x = this.dom.offsetLeft;
        c._sys.y = this.dom.offsetTop;
        c._sys.actualWidth = this.dom.offsetWidth;
        c._sys.actualHeight = this.dom.offsetHeight;
        c._sys.width = this.dom.offsetWidth - (c.margin.left + c.margin.right) - c.padding.left - c.padding.right - (c.borderWidth || 0) * 2;
        c._sys.height = this.dom.offsetHeight - (c.margin.top + c.margin.bottom) - c.padding.top - c.padding.bottom - (c.borderWidth || 0) * 2;

        this.style = "";
        if (c.layoutMode === "absolute")
            this.style = `position: ${c.layoutMode}; left: ${c.x}px; top: ${c.y}px; width: ${Model.lengthCssValue(c.width)}; height: ${Model.lengthCssValue(c.height)}; z-index: ${c.zIndex < 0 ? "unset" : c.zIndex}; padding: ${c.margin.top}px ${c.margin.right}px ${c.margin.bottom}px ${c.margin.left}px; transform-origin: 0 0; transform: scale(${c.scale})`;
        // else if (c.flex >= 0 && c._sys.parent && c._sys.parent.layoutOrientation === "h")
        //     this.style = `flex: ${Model.flexCssValue(c.flex)};  width: 0; height: ${Model.lengthCssValue(c.height)}; z-index: ${c.zIndex < 0 ? "unset" : c.zIndex}; padding: ${c.margin.top}px ${c.margin.right}px ${c.margin.bottom}px ${c.margin.left}px; transform-origin: 0 0; transform: scale(${c.scale})`;
        // else if (c.flex >= 0 && c._sys.parent && c._sys.parent.layoutOrientation === "v")
        //     this.style = `flex: ${Model.flexCssValue(c.flex)};  width: ${Model.lengthCssValue(c.width)}; height: 0; z-index: ${c.zIndex < 0 ? "unset" : c.zIndex}; padding: ${c.margin.top}px ${c.margin.right}px ${c.margin.bottom}px ${c.margin.left}px; transform-origin: 0 0; transform: scale(${c.scale})`;
        else
            this.style = `flex: ${Model.flexCssValue(c.flex)};  width: ${Model.lengthCssValue(c.width)}; height: ${Model.lengthCssValue(c.height)}; z-index: ${c.zIndex < 0 ? "unset" : c.zIndex}; padding: ${c.margin.top}px ${c.margin.right}px ${c.margin.bottom}px ${c.margin.left}px; transform-origin: 0 0; transform: scale(${c.scale})`;

        const es = this.props.model.getDiagramExtendStyle();
        if (es)
            this.style += (";" + es);

        // console.log(this.style);
        this.dom.setAttribute("style", this.style);
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     return nextProps.model !== this.props.model || nextProps.style !== this.props.style;
    // }

    renderUI(model) {

        if (this.props.children)
            return null;

        if (model.hidden)
            return null;

        if (!this.info) {
            const diagrams = DiagramUtils.diagrams;
            this.info = diagrams[model.getType()];
        }

        const ui = this.info ? this.info.uiGetter(model) : null;
        return ui;
    }

    // onClick(e) {
    //     this.designer.selectedItems = this.props.model;
    // }

    // onMouseDoubleClick(e) {
    //     this.designer.selectedItems = this.props.model;
    //     this.props.model.isEdit = true;
    // }

    onMouseDown(e) {

        // if (e.button === 0) {
        //     this.mouseClickSensor.down(e);
        // }

        if (this.props.model.isEdit && this.designer.mode !== "view") {
            e.stopPropagation();
        }
    }

    onMouseUp(e) {

        // if (e.button === 0) {
        //     this.mouseClickSensor.up(e);
        // }

        if (this.props.model.isEdit && this.designer.mode !== "view") {
            e.stopPropagation();
        }
    }

    onMouseWheel(e) {
        if (this.props.model.isEdit && this.designer.mode !== "view")
            e.stopPropagation();
    }

    render() {

        const c = this.props.model;

        if (this.dom) {
            this.updateLayout();
        }

        return (
            <div id={c.id} dataname={c.name} ref={ref => this.setDom(ref)} className={"diagram " + (this.props.className || "") + (c.visibility ? "" : "hidden ") + (this.props.model.getDiagramExtendClass() || "")}>
                {this.props.children}
                {this.dom ? this.renderUI(c) : null}
                {
                    !(c.isEdit || this.designer.mode === "view" || !c.allowMask) ? <div className="mask abs-0"></div> : null
                }
                {
                    this.designer.mode !== "view" && c.showFocus ? <div className="focus abs-0"></div> : null
                }
            </div>
        );
    }
}
